module.exports = __webpack_public_path__ + "img/Gehenna.24f76eca.png";